/* eslint-disable prettier/prettier */
import Vue from "vue";
import VueJWT from "vuejs-jwt";
import AppToast from "../components/frontend/appToast";
import axios from "axios";
import createAuthRefreshInterceptor from "axios-auth-refresh";

const appToast = new AppToast();

Vue.use(VueJWT);

export default class AuthService {
  isLoggedIn() {
    if (localStorage.getItem("token")) {
      var decodedToken = Vue.$jwt.decode(localStorage.getItem("token"));
      if (decodedToken) {
        if (decodedToken.exp < new Date().getTime() / 1000) {
          const tokens = {
            token: localStorage.getItem("token"),
            refreshToken: localStorage.getItem("refreshToken")
          };
          // Function that will be called to refresh authorization
          const refreshAuthLogic = failedRequest =>
            axios
              .post(`api/token/refresh`, tokens)
              .then(response => {
                localStorage.setItem("token", response.data.token);
                localStorage.setItem(
                  "refreshToken",
                  response.data.refreshToken
                );
                failedRequest.response.config.headers["Authentication"] =
                  "Bearer " + response.data.token;
                return Promise.resolve();
              })
              .catch(error => {
                if (error.response) {
                  alert(error.response.data);
                }
                localStorage.removeItem("token");
                localStorage.removeItem("refreshToken");

                return false;
              });

          // Instantiate the interceptor (you can chain it as it returns the axios instance)
          createAuthRefreshInterceptor(axios, refreshAuthLogic);

          axios.interceptors.request.use(request => {
            request.headers["Authorization"] = `Bearer ${this.getToken()}`;
            return request;
          });
        } else {
          return true; // allow access
        }
      }
      return true;
    } else {
      return false;
    }
  }

  getRefreshToken() {
    return localStorage.getItem("refreshToken");
  }

  getToken() {
    return localStorage.getItem("token");
  }

  getUserRole() {
    if (localStorage.getItem("token")) {
      var decodedToken = Vue.$jwt.decode(localStorage.getItem("token"));
      if (decodedToken) {
        return decodedToken.role;
      }
    }
  }

  getLoggedInUserId() {
    if (localStorage.getItem("token")) {
      var decodedToken = Vue.$jwt.decode(localStorage.getItem("token"));
      if (decodedToken) {
        return decodedToken.nameid;
      }
    }
  }

  hasAdminPriv() {
    // check if the object is an array
    const userRole = this.getUserRole();

    if (Object.prototype.toString.call(userRole) === "[object Array]") {
      var hasAdmin = userRole.includes("Main Admin");
      if (hasAdmin) {
        return true;
      } else {
        return false;
      }
    } else {
      if (userRole === "Main Admin") {
        return true;
      } else {
        return false;
      }
    }
  }

  hasTechnicalPrivOnly() {
    // check if the object is an array
    const userRole = this.getUserRole();

    if (Object.prototype.toString.call(userRole) === "[object Array]") {
      var hasAdmin = userRole.includes("Technical Staff");
      if (hasAdmin) {
        return true;
      } else {
        return false;
      }
    } else {
      if (userRole === "Technical Staff") {
        return true;
      } else {
        return false;
      }
    }
  }

  hasTechnicalAdminPriv() {
    // check if the object is an array
    const userRole = this.getUserRole();

    if (Object.prototype.toString.call(userRole) === "[object Array]") {
      var hasAdmin = userRole.includes("Sales & Technical Admin");
      if (hasAdmin) {
        return true;
      } else {
        return false;
      }
    } else {
      if (userRole === "Sales & Technical Admin") {
        return true;
      } else {
        return false;
      }
    }
  }

  hasAdminSalesPriv() {
    // check if the object is an array
    const userRole = this.getUserRole();

    if (Object.prototype.toString.call(userRole) === "[object Array]") {
      var hasAdmin = userRole.includes("Admin Sales");
      if (hasAdmin) {
        return true;
      } else {
        return false;
      }
    } else {
      if (userRole === "Admin Sales") {
        return true;
      } else {
        return false;
      }
    }
  }

  hasAdminSalesAndMainAdminPriv() {
    // check if the object is an array
    const userRole = this.getUserRole();

    if (Object.prototype.toString.call(userRole) === "[object Array]") {
      var hasAdmin = userRole.includes("Admin Sales");
      if (hasAdmin) {
        return true;
      } else {
        return false;
      }
    } else {
      if (userRole === "Admin Sales" || userRole === "Main Admin") {
        return true;
      } else {
        return false;
      }
    }
  }

  hasAdminSalesOrSalesPullOutPriv() {
    // check if the object is an array
    const userRole = this.getUserRole();
    if (
      userRole === "Admin Sales" ||
      userRole === "Main Admin" ||
      userRole === "Sales & Pull Out/Return Staff"
    ) {
      return true;
    } else {
      return false;
    }
  }

  hasAdminSalesOrSalesPoStaffPriv() {
    // check if the object is an array
    const userRole = this.getUserRole();
    if (
      userRole === "Admin Sales" ||
      userRole === "Main Admin" ||
      userRole === "Sales & P.O Staff" ||
      userRole === "Accounting Staff"
    ) {
      return true;
    } else {
      return false;
    }
  }

  hasAdminSalesOrSalesAccountingStaffPriv() {
    // check if the object is an array
    const userRole = this.getUserRole();
    if (
      userRole === "Admin Sales" ||
      userRole === "Main Admin" ||
      userRole === "Accounting Staff" ||
      userRole === "Logistic & Accounting"
    ) {
      return true;
    } else {
      return false;
    }
  }

  hasAdminSalesOrDeliveryPriv() {
    // check if the object is an array
    const userRole = this.getUserRole();
    if (
      userRole === "Admin Sales" ||
      userRole === "Main Admin" ||
      userRole === "Delivery Staff" ||
      userRole === "Logistic & Accounting"
    ) {
      return true;
    } else {
      return false;
    }
  }

  hasSalesPullOutPriv() {
    // check if the object is an array
    const userRole = this.getUserRole();
    if (userRole === "Sales & Pull Out/Return Staff") {
      return true;
    } else {
      return false;
    }
  }
}
